import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { AddPersonModalComponent } from 'src/app/conferences/papers/add-person-modal.component';
import { OrganizationClaims } from 'src/app/_models/generatedEnums';
import { BooleanViewModel, ConferencePaperReviewerViewModel, ConferenceViewModel, ConferenceViewModelWithDetails, CustomSurveyReturnModel, InstructorViewModel, OrderedIdModel, PaperApprovalStatus, PaperEmailViewModel, PaperNotesViewModel, PaperReviewModel, PaperSubmissionFilterViewModel, PaperSubmissionViewModel, PaperTagViewModel, PaperViewModel, StringViewModel, SurveyFileInfoViewModel, TagViewModel, UserViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { AdminCallForPapersService, AdminConferenceSettingsService, OrganizationService } from 'src/app/_services/generatedServices';
import { OrganizationClaimsService } from 'src/app/_services/organization-claims.service';
import { PaperSearchService } from 'src/app/_services/paper-search.service';
import { ToasterService } from 'src/app/_services/toaster.service';
import { AddUsersModalComponent } from '../../../settings/users/add-users-modal.component';
import { AddEmailModalComponent } from './add-email/add-email-modal.component';
import { AddNoteModalComponent } from './add-note/add-note-modal.component';
import { PresenterDetailsComponent } from './presenter-details.component';
import * as customBuild from 'src/ckCustomBuild/ckeditor';
import { CKEditorUploadAdapter } from "../../../../../_helpers/ckeditor-upload-adapter";
import { HttpEventType } from "@angular/common/http";

@Component({
  selector: 'bxl-submission-approval-editor',
  templateUrl: 'submission-approval-editor.component.html',
})
export class SubmissionApprovalEditorComponent implements OnInit {
  initialized = false;
  paper: PaperSubmissionViewModel;
  OrganizationClaims = OrganizationClaims;
  submitReviewComplete: Promise<{}> | undefined;
  tab = 1;
  filter = '';
  filterChanged: Subject<string> = new Subject<string>();
  approvalComplete: Promise<{}> | undefined;
  items: string[] = [];
  organizationId: any;
  conferenceId: any;
  editingReview: boolean;
  PaperApprovalStatus = PaperApprovalStatus;
  paperStatuses = Object.values(PaperApprovalStatus).filter((x) => typeof x === 'string');
  htmlEditorConfig = {
    toolbar: {
      items: ['bold', 'italic', 'underline', 'link', 'alignment', 'bulletedList', 'numberedList', '|', 'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor'],
      shouldNotGroupWhenFull: false,
    },
    fontSize: {
      options: [9, 11, 13, 'default', 17, 19, 21],
    },
    mediaEmbed: {
      previewsInData: true,
    },
  };

  public Editor:any = customBuild;


  submissionId: number;
  reviewScore?: number = null;
  reviewFeedback: string;
  assignees: InstructorViewModel[];
  contentAreas = [
    { name: 'Animal Behavior (AB)', value: 'AB' },
    { name: 'Autism (AUT)', value: 'AUT' },
    { name: 'Brain Injury Rehabilitation (BIR)', value: 'BIR' },
    { name: 'Business Practices/Leadership (BPL)', value: 'BPL' },
    { name: 'Community Applications (CA)', value: 'CA' },
    { name: 'Culture/Diversity (CUL)', value: 'CUL' },
    { name: 'Developmental Disabilities (DD)', value: 'DD' },
    { name: 'Dissemination/Public Policy (DPP)', value: 'DPP' },
    { name: 'Education /Schools (ES)', value: 'ES' },
    { name: 'Environmental Sustainability (EVS)', value: 'EVS' },
    { name: 'Ethics (ETH)', value: 'ETH' },
    { name: 'Gerontology (GER)', value: 'GER' },
    { name: 'Health, Fitness & Sports (HF)', value: 'HF' },
    { name: 'Mental Health (MH)', value: 'MH' },
    { name: 'Organizational Behavior Management (OBM)', value: 'OBM' },
    { name: 'Other ABA Service (OAS)', value: 'OAS' },
    { name: 'Pediatric (PED)', value: 'PED' },
    { name: 'Public Health (PH)', value: 'PH' },
    { name: 'Professional (PRO)', value: 'PRO' },
    { name: 'Substance Use Disorders (SUD)', value: 'SUD' },
    { name: 'Theoretical/Conceptual/Philosophical', value: 'TCP' },
    { name: 'Teaching/Training/Supervision (TTS)', value: 'TTS' },
    { name: 'Verbal Behavior (VB)', value: 'VB' },
  ];

  durations = [
    { name: '50 Minutes', value: 50 },
    { name: '80 Minutes', value: 80 },
  ];

  yesNoUnsure = [
    { name: 'Yes', value: 'Yes' },
    { name: 'No', value: 'No' },
    { name: 'Unsure', value: 'Unsure' },
  ];

  yesNo = [
    { name: 'Yes', value: true },
    { name: 'No', value: false },
  ];

  reviewMode: any;
  userLoading: boolean;
  reviewerData: Observable<ConferencePaperReviewerViewModel[]>;
  reviewError: string;
  sourcePage: string;
  nextPaperId: number;
  previousPaperId: number;
  tags: PaperTagViewModel[];
  conference: ConferenceViewModel;
  blindReview: boolean;
  customSurveyData: CustomSurveyReturnModel[];

  constructor(private router: Router, private route: ActivatedRoute, private paperSearchService: PaperSearchService, private toaster: ToasterService, private orgAdminService: AdminConferenceSettingsService, private modalService: NgbModal, private orgService: OrganizationService, public claims: OrganizationClaimsService, private cfpService: AdminCallForPapersService, public auth: AuthenticationService) {
    this.filterChanged.pipe(debounceTime(500), distinctUntilChanged()).subscribe((model) => {
      this.filter = model;
      this.getUsers();
    });
  }

  onReady(editor): void {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return new CKEditorUploadAdapter(loader, this.auth.getToken());
    };
  }

  ngOnInit(): void {
    if (window.innerWidth < 768) {
      this.tab = 5;
    } else {
      this.tab = 1;
    }

    this.route.queryParamMap.subscribe((queryParams) => {
      var tab = +queryParams.get('tab');
      if (tab) {
        this.tab = tab;
      }

      this.route.data.subscribe((routeData) => {
        this.route.paramMap.subscribe((params) => {
          var confId = params.get('conferenceId');
          if (!confId) {
            confId = params.get('conferenceSlug');
          }

          this.submissionId = +params.get('submissionId');
          this.reviewMode = JSON.parse(routeData['reviewMode']);
          this.sourcePage = queryParams.get('sourcePage');
          console.log('Review Mode: ' + this.reviewMode);

          this.nextPaperId = this.paperSearchService.getNextPaperId(this.submissionId);
          this.previousPaperId = this.paperSearchService.getPreviousPaperId(this.submissionId);

          if (!this.auth.user) {
            this.auth.fetchUserProfile().subscribe();
          }

          this.orgService.getConferenceBySlugBasic(confId).subscribe((conf) => {
            this.organizationId = conf.organizationId;
            this.conferenceId = conf.id;
            this.conference = conf;

            this.orgAdminService.getPaperReviewersForConference(this.organizationId.toString(), this.conferenceId).subscribe((reviewers) => {
              this.blindReview = Enumerable.from(reviewers).any((x) => x.isBlind && x.id == this.auth.user.id);

              this.cfpService.getSubmissionById(this.organizationId, this.conferenceId, this.submissionId).subscribe((paper) => {
                this.paper = paper;
                var existingReview = Enumerable.from(this.paper.reviews).firstOrDefault((x) => x.userId == this.auth.user.id);
                this.reviewFeedback = existingReview?.feedback;
                this.reviewScore = existingReview?.score;

                this.cfpService.getCustomSurveyData(this.organizationId, this.conferenceId, this.paper.id).subscribe((customData) => {
                  this.cfpService.getTagsForConference(this.organizationId, this.conferenceId).subscribe((tags) => {
                    this.cfpService.searchAdminUsers(this.organizationId, '').subscribe((result) => {
                      this.assignees = result;

                      this.loadCustomSurveyData(customData);
                      this.handleFilter('');
                      this.tags = tags;
                      //this.reviewCriteria = Enumerable.from(paper.paperType.reviewCriteria).groupJoin(Enumerable.from(paper.criter))
                      this.initialized = true;
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  viewBio(user: InstructorViewModel) {
    const modalRef = this.modalService.open(PresenterDetailsComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.organizationId = this.organizationId;
    modalRef.componentInstance.conferenceId = this.conferenceId;
    modalRef.componentInstance.submissionId = this.submissionId;
    modalRef.componentInstance.route = this.route;
    modalRef.componentInstance.paperId = this.paper.id;
    modalRef.componentInstance.user = user;
    modalRef.result.then(
      (result) => {},
      (reason) => {
        //this.getData();
      }
    );
  }

  getCustomQuestionResponse(questionId: number) {
    var answer = Enumerable.from(this.paper.paperCustomQuestionResponses).firstOrDefault((x) => x.paperCustomQuestionId == questionId);

    if (answer) {
      return answer.answer;
    }

    return '-- No Value --';
  }

  removePresenter(type: string, id: number) {
    this.toaster.confirmDialog('Are you sure you want to remove this person?', 'Are you sure?').subscribe((result) => {
      if (result) {
        switch (type) {
          case 'Discussant':
            break;
          case 'Chair':
            break;
          case 'Panelist':
            this.cfpService.removePanelistFromPaper(this.organizationId, this.conferenceId, this.paper.id, id).subscribe(() => {
              this.paper.panelists.splice(
                this.paper.panelists.findIndex((x) => x.id == id),
                1
              );
              this.toaster.success('Panelist removed from paper.');
            });
            break;
          case 'Presenter':
            this.cfpService.removePresenterFromPaper(this.organizationId, this.conferenceId, this.paper.id, id).subscribe(() => {
              this.paper.presenters.splice(
                this.paper.presenters.findIndex((x) => x.id == id),
                1
              );
              this.toaster.success('Presenter removed from paper.');
            });
            break;
          case 'Author':
            break;
        }
      }
    });
  }

  addPresenter(type: string) {
    const modalRef = this.modalService.open(AddPersonModalComponent, { size: 'lg', keyboard: false, ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.personType = type;

    modalRef.result.then(
      (result) => {},
      (instructor) => {
        switch (type) {
          case 'Discussant':
            this.paper.discussant = instructor;
            break;
          case 'Chair':
            this.paper.chair = instructor;
            break;
          case 'Panelist':
            this.paper.panelists.push(instructor);
            this.cfpService.addPanelistToPaper(this.organizationId, this.conferenceId, this.paper.id, instructor.id).subscribe();
            break;
          case 'Presenter':
            this.paper.presenters.push(instructor);
            this.cfpService.addPresenterToPaper(this.organizationId, this.conferenceId, this.paper.id, instructor.id).subscribe();
            break;
          case 'Author':
            this.paper.authors.push(instructor);
            break;
        }
      }
    );
  }

  approve() {
    if (!this.conference.approvalTemplateSet) {
      this.toaster.messageDialog('You must set an approval email template before approving a paper.', 'Error', 'OK').subscribe((result) => {});
      return;
    }

    this.toaster.confirmDialog('Are you sure you want to accept this paper? This will notify the submitting user and ask them to finalize the presentation.', 'Accept?', 'Accept', 'Cancel').subscribe((confirmResult) => {
      if (confirmResult) {
        this.approvalComplete = new Promise((resetButton: any, reject) => {
          this.cfpService.acceptPaper(this.organizationId, this.conferenceId, this.submissionId).subscribe(
            (result) => {
              this.paper = result;
              resetButton();
            },
            (error) => resetButton()
          );
        });
      }
    });
  }
  renotify() {
    this.toaster.confirmDialog('Are you sure you want to re-notify the submitting user? This will notify the submitting user and ask them to finalize the presentation.', 'Notify?', 'Notify', 'Cancel').subscribe((confirmResult) => {
      if (confirmResult) {
        this.approvalComplete = new Promise((resetButton: any, reject) => {
          this.cfpService.reNotifyAcceptedPaper(this.organizationId, this.conferenceId, this.submissionId).subscribe(
            (result) => {
              this.paper = result;
              this.toaster.success('Re-notified user', 'Success!');
              resetButton();
            },
            (error) => resetButton()
          );
        });
      }
    });
  }

  reject(sendEmail: boolean) {
    if (!this.conference.rejectTemplateSet) {
      this.toaster.messageDialog('You must set a rejection email template before rejecting a paper.', 'Error', 'OK').subscribe((result) => {});
      return;
    }

    this.toaster.confirmDialog('Are you sure you want to reject this paper? This will notify the submitting user.', 'Reject?').subscribe((result) => {
      this.approvalComplete = new Promise((resetButton: any, reject) => {
        this.cfpService.rejectPaper(this.organizationId, this.conferenceId, this.submissionId, sendEmail).subscribe(
          (result) => {
            this.paper = result;
            resetButton();
          },
          (error) => resetButton()
        );
      });
    });
  }

  addNote() {
    const modalRef = this.modalService.open(AddNoteModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.organizationId = this.organizationId;
    modalRef.componentInstance.conferenceId = this.conferenceId;
    modalRef.componentInstance.submissionId = this.submissionId;
    modalRef.result.then(
      (result: PaperNotesViewModel[]) => {
        this.paper.notes = result;
      },
      (reason) => {
        //this.getData();
      }
    );
  }

  addEmail() {
    const modalRef = this.modalService.open(AddEmailModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.organizationId = this.organizationId;
    modalRef.componentInstance.conferenceId = this.conferenceId;
    modalRef.componentInstance.paperSubmission = this.paper;
    modalRef.result.then(
      (result: PaperEmailViewModel[]) => {
        this.paper.emails = result;
      },
      (reason) => {
        //this.getData();
      }
    );
  }

  propertyUpdated(property: string) {
    var model = new StringViewModel();
    model.value = this.paper[property];
    this.cfpService.updateSubmissionField(this.organizationId, this.conferenceId, this.submissionId, property, model).subscribe((result) => {
      this.toaster.success('Property Saved', 'Updated');
    });
  }

  takeIt() {
    this.cfpService.updateAssignee(this.organizationId, this.conferenceId, this.paper.id, this.auth.user.id).subscribe((result) => {
      this.toaster.success('Assigned to ' + result.fullName, 'Assignment Updated');
      this.paper.assignedTo = result;
    });
  }
  updateAssignment(evt: any) {
    this.cfpService.updateAssignee(this.organizationId, this.conferenceId, this.paper.id, evt.id).subscribe((result) => {
      this.toaster.success('Assigned to ' + result.fullName, 'Assignment Updated');
      this.paper.assignedTo = result;
    });
  }

  public updateTags(evt: PaperTagViewModel[]) {
    console.log(evt);
    this.cfpService.updateTags(this.organizationId, this.conferenceId, this.paper.id, evt).subscribe((result) => {
      this.toaster.success('Tags have been updated', 'Tags Saved');
    });
  }

  public updateReviewers(evt: InstructorViewModel[]) {
    console.log(evt);
    var model = new OrderedIdModel();
    model.ids = Enumerable.from(evt)
      .select((x) => x.id)
      .toArray();

    this.cfpService.updateReviewers(this.organizationId, this.conferenceId, this.paper.id, model).subscribe((result) => {
      this.toaster.success('Any new reviwers have been notified', 'Reviewer Saved');
    });
  }

  compareFn = this._compareFn.bind(this);
  _compareFn(a, b) {
    return a?.id === b?.id;
  }

  saveReviewCriteria(criteriaId: number, evt) {
    console.log(evt);
    console.log(criteriaId);
    var model = new BooleanViewModel();
    model.value = evt;
    this.cfpService.updateReviewCriteria(this.organizationId, this.conferenceId, this.submissionId, criteriaId, model).subscribe((result) => {
      this.toaster.success('Criteria Saved!', 'Saved');
    });
  }

  replyEmail(existing: PaperEmailViewModel) {
    const modalRef = this.modalService.open(AddEmailModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.organizationId = this.organizationId;
    modalRef.componentInstance.conferenceId = this.conferenceId;
    modalRef.componentInstance.paperSubmission = this.paper;
    modalRef.componentInstance.replyEmail = existing;
    modalRef.result.then(
      (result: PaperEmailViewModel[]) => {
        this.paper.emails = result;
      },
      (reason) => {
        //this.getData();
      }
    );
  }

  forwardEmail(existing: PaperEmailViewModel) {
    const modalRef = this.modalService.open(AddEmailModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.organizationId = this.organizationId;
    modalRef.componentInstance.conferenceId = this.conferenceId;
    modalRef.componentInstance.paperSubmission = this.paper;
    modalRef.componentInstance.forwardEmail = existing;
    modalRef.result.then(
      (result: PaperEmailViewModel[]) => {
        this.paper.emails = result;
      },
      (reason) => {
        //this.getData();
      }
    );
  }

  submitReview() {
    if (this.reviewScore == null) {
      this.reviewError = 'Please choose a rating before you submit.';
      return;
    }

    this.submitReviewComplete = new Promise((resetButton: any, reject) => {
      var model = new PaperReviewModel();
      model.feedback = this.reviewFeedback;
      model.score = this.reviewScore;
      this.cfpService.submitPaperReview(this.organizationId, this.conferenceId, this.submissionId, model).subscribe(
        (result) => {
          this.paper = result;
          this.editingReview = false;
          resetButton();
          this.toaster.success('Review Submitted', 'Success');
        },
        () => resetButton()
      );
    });
  }

  get averageReview(): number {
    return Enumerable.from(this.paper.reviews).average((x) => x.score);
  }

  get currentUserHasReview(): boolean {
    var index = this.paper.reviews.findIndex((x) => x.userId == this.auth.user.id);
    return index > -1;
  }

  get currentUserReview(): PaperReviewModel {
    return this.paper.reviews.find((x) => x.userId == this.auth.user.id);
  }

  getUsers() {
    this.cfpService.searchAdminUsers(this.organizationId, this.filter).subscribe((result) => {
      this.items = result.map((x) => x.firstName + '-' + x.lastName);
    });
  }

  searchTerm(evt: any) {
    this.filterChanged.next(evt);
    console.log(evt);
  }

  public handleFilter(value) {
    this.userLoading = true;
    this.reviewerData = this.orgAdminService.getPaperReviewersForConference(this.organizationId, this.conferenceId).pipe(
      debounceTime(500),
      distinctUntilChanged(),
      map((x) => {
        console.log('map');
        return x;
      }),
      tap(() => {
        console.log('tap');
        this.userLoading = false;
      })
    );
  }

  addComment(note: PaperNotesViewModel) {
    var model = new StringViewModel();
    model.value = note.newCommentEntry;

    this.cfpService.createNoteComment(this.organizationId, this.conferenceId, note.id, model).subscribe((result) => {
      result.commentsExpanded = true;

      var index = this.paper.notes.findIndex((x) => x.id == note.id);
      this.paper.notes[index] = result;
    });
    console.log(note.newCommentEntry);
  }

  public valueNormalizer = (text: Observable<string>) =>
    text.pipe(
      map((content: string) => {
        var model = new InstructorViewModel();
        model.email = content;
        model.fullName = content;
        return <any>model;
      })
    );

  public tagValueNormalizer = (text: Observable<string>) =>
    text.pipe(
      map((content: string) => {
        var model = new PaperTagViewModel();
        model.label = content;
        return <any>model;
      })
    );

  exit() {
    if (this.paperSearchService.papers) {
      var index = this.paperSearchService.papers.findIndex((x) => x.id == this.paper.id);
      if (index > -1) {
        var filter = new PaperSubmissionFilterViewModel();
        filter.searchText = this.paper.id.toString();
        this.cfpService.getSubmissionsForConference(this.organizationId, this.conferenceId, false, filter, 0, 1).subscribe((updatedPaper) => {
          this.paperSearchService.papers[index] = updatedPaper.results[0];
        });
      }
    }
    console.log(this.sourcePage);
    if (this.reviewMode && this.sourcePage == 'myPapers') {
      this.router.navigate(['../../../submissions/reviews'], { relativeTo: this.route, fragment: 'paper' + this.paper.id.toString() });
    } else if (this.reviewMode && this.sourcePage == 'allPapers') {
      this.router.navigate(['../../../submissions/reviews/all-papers'], { relativeTo: this.route, fragment: 'paper' + this.paper.id.toString() });
    } else if (this.sourcePage == 'inbox') {
      console.log('returning to inbox');
      this.router.navigate(['../../../abstracts/inbox'], { relativeTo: this.route });
    } else {
      this.router.navigate(['../../'], { relativeTo: this.route, fragment: 'paper' + this.paper.id.toString() });
    }
  }

  private loadCustomSurveyData(customData:CustomSurveyReturnModel[]) {
    this.customSurveyData = customData;

  }

  public downloadFile(file: SurveyFileInfoViewModel) {
    //const src = `data:text/csv;base64,${file.name}`;

    const a = document.createElement('a');
      //const objectUrl = URL.createObjectURL(file.content);
      a.href = file.content;
      a.download = file.name;
      a.click();
      URL.revokeObjectURL(file.content);

    
  }
}
